import Rails from '@rails/ujs';

export const safelyFetchJson = async (url, config) => {
  let data = '';
  try {
    const response = await fetch(url, {
      ...config,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': Rails.csrfToken(),
        ...(config?.headers || [])
      }
    });

    data = await response.text();
    return JSON.parse(data);
  } catch (e) {
    // If we're not getting a status code and only html
    // Our session is probably expired best way to currently update this is
    // By doing a hard refresh
    // To test this, clear site data and attempt some actions
    if (data.indexOf('<html>') !== -1) {
      window.location.reload();
      throw new Error('Expected Json Response');
    }

    throw new Error('Unexpected Error Occurred');
  }
};
